var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.197,
    height: 11.142,
    viewBox: "0 0 11.197 11.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-0.001 -1.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50902",
    "data-name": "Path 50902",
    d: "M6.963,3.148,9.241,5.426,3.475,11.191,1.2,8.914ZM10.969,2.6,9.953,1.583a1.008,1.008,0,0,0-1.424,0l-.973.973L9.834,4.834,10.969,3.7A.777.777,0,0,0,10.969,2.6ZM.007,12.115a.259.259,0,0,0,.314.308l2.538-.615L.582,9.531Z",
    transform: "translate(0)",
    fill: "#afafaf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterEdit);
export default __webpack_public_path__ + "static/media/icon_filter_edit.9332303ff8a8d4abdccc2c73b8474b95.svg";
export { ForwardRef as ReactComponent };